import NewIncentive from './NewIncentive.container';

export default NewIncentive;
